var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "collectPaymentModal",
        "modal-class": "collect-payment-modal",
        centered: "",
        "hide-footer": "",
        title: "Collect Payment",
      },
      model: {
        value: _vm.showModal,
        callback: function ($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal",
      },
    },
    [
      _c("p", { staticClass: "payment-type-label" }, [_vm._v("Cash")]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "payment-type-buttons" },
        [
          _c(
            "b-col",
            { attrs: { cols: "4" } },
            [
              _c(
                "b-btn",
                {
                  staticClass: "payment-type-button",
                  attrs: { variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.showEnterPaymentModal(
                        _vm.paymentMethods.MANUAL,
                        false
                      )
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.tab && _vm.tab.stats
                          ? _vm.formatMoney(_vm.tab.stats.balance_due)
                          : 0
                      ) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "4" } },
            [
              _c(
                "b-btn",
                {
                  staticClass: "payment-type-button",
                  attrs: { variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.showEnterPaymentModal(
                        _vm.paymentMethods.MANUAL
                      )
                    },
                  },
                },
                [_vm._v("\n        Custom Amount\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("p", { staticClass: "payment-type-label" }, [_vm._v("Payment")]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "payment-type-buttons" },
        [
          _c(
            "b-col",
            { attrs: { cols: "4" } },
            [
              _c(
                "b-btn",
                {
                  staticClass: "payment-type-button",
                  attrs: { variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.showEnterPaymentModal(_vm.paymentMethods.OTHER)
                    },
                  },
                },
                [_vm._v("\n        Add Payment\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("p", { staticClass: "payment-type-label" }, [_vm._v("Adjustments")]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "payment-type-buttons" },
        [
          _c(
            "b-col",
            { attrs: { cols: "4" } },
            [
              _c(
                "b-btn",
                {
                  staticClass: "payment-type-button",
                  attrs: { variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.showEnterAdjustmentModal(
                        _vm.adjustmentTypes.DISCOUNT
                      )
                    },
                  },
                },
                [_vm._v("\n        Discount\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "4" } },
            [
              _c(
                "b-btn",
                {
                  staticClass: "payment-type-button",
                  attrs: { variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.showEnterAdjustmentModal(
                        _vm.adjustmentTypes.REFUND
                      )
                    },
                  },
                },
                [_vm._v("\n        Refund\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("enter-payment-modal", {
        ref: "enterPaymentModal",
        attrs: { payer: _vm.payer },
        on: { submit: _vm.onSubmitPayment },
      }),
      _vm._v(" "),
      _c("tip-payment-modal", {
        ref: "tipPaymentModal",
        attrs: { payer: _vm.payer, tab: _vm.tab },
        on: { submit: _vm.onSubmitGratuity },
      }),
      _vm._v(" "),
      _c("enter-adjustment-modal", {
        ref: "enterAdjustmentModal",
        on: { submit: _vm.onSubmitAdjustment },
      }),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "payment-spinner" },
            [_c("spinner-loader")],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }